import { Link } from "react-router-dom";
import { MapPin, BadgeCheck, Briefcase, ArrowUpRight, Star } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const PLACEHOLDER = "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&q=80&w=600";

export function ExpertCard({ expert }) {
  return (
    <Link to={`/expert/${expert.id}`} data-testid={`expert-card-${expert.id}`}
      className="group relative bg-slate-900 text-white border border-slate-800 hover:border-orange-600 transition-colors flex flex-col overflow-hidden">
      <div className="relative aspect-[4/3] bg-slate-800 overflow-hidden">
        <img src={mediaUrl(expert.photo) || PLACEHOLDER} alt={expert.name}
          onError={(e) => { e.currentTarget.src = PLACEHOLDER; }}
          className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent" />
        {expert.senior && (
          <span className="absolute top-3 right-3 inline-flex items-center gap-1 bg-amber-500 text-slate-950 text-[10px] font-black uppercase tracking-wider px-2.5 py-1" data-testid={`veteran-badge-${expert.id}`}>
            <Star className="w-3.5 h-3.5 fill-slate-950" /> Veteran
          </span>
        )}
        {expert.endorsed && (
          <span className="absolute top-3 left-3 inline-flex items-center gap-1 bg-orange-600 text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1" data-testid={`endorsed-badge-${expert.id}`}>
            <BadgeCheck className="w-3.5 h-3.5" /> OXO Endorsed
          </span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-bold text-lg leading-tight group-hover:text-orange-500 transition-colors">{expert.name}</h3>
        {expert.company && <span className="text-xs text-slate-400 mt-0.5">{expert.company}</span>}
        <div className="flex flex-wrap gap-1.5 mt-3">
          {(expert.specializations || []).slice(0, 2).map((s) => (
            <span key={s} className="text-[10px] uppercase tracking-wide font-semibold text-orange-400 border border-orange-900/60 bg-orange-950/30 px-2 py-0.5">{s}</span>
          ))}
        </div>
        <div className="mt-auto pt-4 flex items-center justify-between text-xs text-slate-400 border-t border-slate-800 mt-4">
          <span className="flex items-center gap-1.5">{expert.location ? <><MapPin className="w-3.5 h-3.5" /> {expert.location}</> : expert.years_experience ? <><Briefcase className="w-3.5 h-3.5" /> {expert.years_experience} ani</> : ""}</span>
          <ArrowUpRight className="w-4 h-4 text-orange-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
        </div>
      </div>
    </Link>
  );
}

export default ExpertCard;
